

// const accountInfoResponse = await getAccountInfo(clientId);

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccount, getAccountInfo, getAccountSummary, getClientAccountTree } from "../../api/request/dashboard/dashboard";
import { setAccountData } from "../Slices/accountSummary";
import { setUserDetails } from "../Slices/userSlice";


export const GetAccount = createAsyncThunk('account/get', async (accountId, { dispatch, getState, rejectWithValue }) => {
    try {
        const clientId = getState().user?.userDetail?.id
        console.log(accountId)
        document.title = `${accountId} - Vertexfx Trader`
        localStorage.setItem("accountID", accountId);
        const response = await getAccount(accountId);
        dispatch(setAccountData(response?.data || {}));
        return accountId;
    } catch (err) {
        rejectWithValue(err)
    }
})

export const fetchAccountTree = createAsyncThunk('accountTree/get', async (_, { getState, rejectWithValue, dispatch }) => {
    try {
        const clientId = getState().user?.userDetail?.id
        const { data } = await getClientAccountTree(clientId);
        if (Array.isArray(data)) {
            for (const item of data) {
                console.log(Object.keys(item.accounts))
                const accounts = Object.keys(item.accounts)
                if (accounts.length) {
                    dispatch(GetAccount(accounts[0]));
                    dispatch(setUserDetails(item?.client))
                    break;
                }
            }
            return data;
        } else {
            console.warn("Unexpected API response format:", data);
            return []
        }
    } catch (err) {

    }
})

export const fetchAccountSummary = createAsyncThunk('accountSummary/get', async (accountId, { getState }) => {
    try {
        const { data } = await getAccountSummary(accountId);
        return data || {};
    } catch (err) {
        return {};
    }
})